import {
  base,
  baseSepolia,
  chiliz,
  gnosis,
  polygon,
  polygonAmoy,
  spicy,
} from 'viem/chains'
import { type ChainId } from '@azuro-org/toolkit'
import { type IconName } from 'components/ui'
import { CLASSIC_WEBSITE_URL } from 'src/config/env'

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL as string
const companyName = 'DGBet - Powered by AZURO'
const privyAppId = process.env.NEXT_PUBLIC_PRIVY_APP_ID as string
const mtPelerinToken = process.env.NEXT_PUBLIC_MTPERELIN_TOKEN as string

const rpcByChains: Record<ChainId, string> = {
  [gnosis.id]: 'https://gnosis-rpc.publicnode.com',
  [polygon.id]: 'https://polygon-bor-rpc.publicnode.com',
  [polygonAmoy.id]: 'https://rpc-amoy.polygon.technology',
  [chiliz.id]: 'https://chiliz-rpc.publicnode.com',
  [spicy.id]: 'https://chiliz-spicy-rpc.publicnode.com',
  [base.id]: 'https://base-rpc.publicnode.com',
  [baseSepolia.id]: 'https://base-sepolia-rpc.publicnode.com',
} as const

const chainIcons: Record<ChainId, IconName> = {
  [gnosis.id]: 'networks/gnosis',
  [polygon.id]: 'networks/polygon',
  [polygonAmoy.id]: 'networks/polygon',
  [chiliz.id]: 'networks/chiliz',
  [spicy.id]: 'networks/chiliz',
  [base.id]: 'networks/base',
  [baseSepolia.id]: 'networks/base',
}

const currencyIcons: Record<ChainId, IconName> = {
  [gnosis.id]: 'currency/wxdai',
  [polygon.id]: 'currency/usdt',
  [polygonAmoy.id]: 'currency/azusd',
  [chiliz.id]: 'currency/wchz',
  [spicy.id]: 'currency/wchz',
  [base.id]: 'currency/weth',
  [baseSepolia.id]: 'currency/weth',
}

const sportsOrder = [
  'politics',
  'football',
  'basketball',
  'tennis',
  'cricket',
  'mma',
  'boxing',
  'ice-hockey',
  'american-football',
  'baseball',
  'rugby-union',
  'rugby-league',
]

const links = {
  about: 'https://dgbet.fun/about-us/',
  blog: 'https://dgbet.fun/blog/',
  terms: 'https://dgbet.fun/terms-and-conditions/',
  policy: 'https://dgbet.fun/privacy-policy/',
  rulesAndDisclaimers: 'https://dgbet.fun/rules-disclaimers/',
  waves: 'https://azuro.org/app/waves',
}

const navigationLinks = {
  profile: '/profile',
  promotions: 'https://dgbet.fun/contests/',
  whitepaper: 'https://dgbet.gitbook.io/whitepaper',
  blog: 'https://dgbet.fun/blog/',
  about: 'https://dgbet.fun/about-us/',
  classic: CLASSIC_WEBSITE_URL || '/',
}

const socialLinks = {
  instagram: 'https://www.instagram.com/dgbet_official_/#',
  telegram: 'https://t.me/+ID8zItSE9QJjOTM1',
  twitter: 'https://x.com/dgbet_official',
  discord: 'https://discord.com/invite/VeGrqdNKU5',
}

const defaultSlippageValues = ['5', '10', '15']
const defaultQuickBetsValues = ['50', '100']

const localStorageKeys = {
  slippage: 'slippage',
  quickBet: 'quickBet',
  gameMarketsView: 'gameMarketsView',
  collapsedMarkets: 'collapsedMarkets',
  oddsView: 'oddsView',
  timeFormat: 'timeFormat',
}

export default {
  baseUrl,
  companyName,
  rpcByChains,
  mtPelerinToken,
  topPageGamePerSportLimit: 10,
  chainIcons,
  currencyIcons,
  sportsOrder,
  links,
  defaultSlippageValues,
  defaultSlippage: '10',
  defaultQuickBetsValues,
  localStorageKeys,
  privyAppId,
  navigationLinks,
  socialLinks,
}
